import { render, staticRenderFns } from "./LoginIndex.vue?vue&type=template&id=2517a026&scoped=true&"
import script from "./LoginIndex.vue?vue&type=script&lang=js&"
export * from "./LoginIndex.vue?vue&type=script&lang=js&"
import style0 from "./LoginIndex.vue?vue&type=style&index=0&id=2517a026&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2517a026",
  null
  
)

export default component.exports